var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 3.03365V0.292402C16.9404 0.804545 18.9294 1.91275 20.5092 3.4926C22.0891 5.07245 23.1973 7.0614 23.7094 9.23615H20.9625C20.5133 7.77497 19.7134 6.44588 18.6326 5.36477C17.5518 4.28365 16.2229 3.48336 14.7619 3.03365H14.7656ZM3.08065 9.23428H0.337524C0.849667 7.05952 1.95787 5.07057 3.53772 3.49072C5.11757 1.91087 7.10652 0.80267 9.28127 0.290527V3.0374C7.82044 3.48693 6.49172 4.28694 5.41096 5.36771C4.33019 6.44848 3.53017 7.77719 3.08065 9.23803V9.23428ZM9.28127 20.9193V23.6605C7.10676 23.1485 5.11797 22.0406 3.53814 20.4611C1.95832 18.8816 0.849975 16.8931 0.337524 14.7187H3.08065C3.53017 16.1795 4.33019 17.5082 5.41096 18.589C6.49172 19.6697 7.82044 20.4698 9.28127 20.9193ZM20.9663 14.7187H23.7075C23.1954 16.8934 22.0872 18.8824 20.5073 20.4622C18.9275 22.0421 16.9385 23.1503 14.7638 23.6624V20.9193C16.225 20.47 17.5541 19.6701 18.6352 18.5893C19.7163 17.5086 20.5166 16.1797 20.9663 14.7187Z",
    fill: "#00394D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.85bb2f6603bdd890eec7435a4723e98c.svg";
export { ForwardRef as ReactComponent };